export function loadGiftList(query) {
  return {
    type: 'LOAD_GIFT_LIST',
    query,
    willReload: !!query,
  };
}

export function loadGiftListCompletion(error = null, list = []) {
  return {
    type: 'LOAD_GIFT_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadStoreList(query) {
  return {
    type: 'LOAD_STORE_LIST',
    query,
    willReload: !!query,
  };
}

export function loadStoreListCompletion(error = null, list = []) {
  return {
    type: 'LOAD_STORE_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadCashList(query) {
  return {
    type: 'LOAD_CASH_LIST',
    query,
    willReload: !!query,
  };
}

export function loadCashListCompletion(error = null, list = []) {
  return {
    type: 'LOAD_CASH_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadPostageList(query) {
  return {
    type: 'LOAD_POSTAGE_LIST',
    query,
    willReload: !!query,
  };
}

export function loadPostageListCompletion(error = null, list = []) {
  return {
    type: 'LOAD_POSTAGE_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadCoupon(code) {
  return {
    type: 'LOAD_COUPON',
    code,
  };
}

export function loadCouponCompletion(code, error = null, data = {}) {
  return {
    type: 'LOAD_COUPON_COMPLETION',
    code,
    error,
    data,
  };
}

export function loadGiftDetail(giftId) {
  return {
    type: 'LOAD_GIFT_DETAIL',
    giftId,
  };
}

export function loadGiftDetailCompletion(giftId, error = null, data = {}) {
  return {
    type: 'LOAD_GIFT_DETAIL_COMPLETION',
    giftId,
    error,
    data,
  };
}

export function batchGetCoupon(couponIds) {
  return {
    type: 'BATCH_GET_COUPON',
    couponIds,
  };
}

export function batchGetCouponCompletion(error = null, list = []) {
  return {
    type: 'BATCH_GET_COUPON_COMPLETION',
    error,
    list,
  };
}

export function batchCancelDonateCoupon(couponIds) {
  return {
    type: 'BATCH_CANCEL_DONATE_COUPON',
    couponIds,
  };
}

export function batchCancelDonateCouponCompletion(error = null, list = []) {
  return {
    type: 'BATCH_CANCEL_DONATE_COUPON_COMPLETION',
    error,
    list,
  };
}

export function batchDonateCoupon(couponIds) {
  return {
    type: 'BATCH_DONATE_COUPON',
    couponIds,
  };
}

export function batchDonateCouponCompletion(error = null, list = []) {
  return {
    type: 'BATCH_DONATE_COUPON_COMPLETION',
    error,
    list,
  };
}

export function loadPickerGiftList(query) {
  return {
    type: 'LOAD_PICKER_GIFT_LIST',
    query,
    willReload: !!query,
  };
}

export function loadPickerGiftListCompletion(error, list) {
  return {
    type: 'LOAD_PICKER_GIFT_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadReceivedCouponList() {
  return {
    type: 'LOAD_RECEIVED_COUPON_LIST',
  };
}

export function loadReceivedCouponListCompletion(error, data) {
  return {
    type: 'LOAD_RECEIVED_COUPON_LIST_COMPLETION',
    error,
    list: (data && data.first) || [],
    defindList: (data && data.second) || [],
  };
}

export function loadNewuserCouponList() {
  return {
    type: 'LOAD_NEWUSER_COUPON_LIST',
  };
}

export function loadNewuserCouponListCompletion(error, data) {
  return {
    type: 'LOAD_NEWUSER_COUPON_LIST_COMPLETION',
    error,
    list: (data && data.listData) || [],
  };
}

export function loadCouponPkg(pkgId) {
  return {
    type: 'LOAD_COUPON_PKG',
    pkgId,
  };
}

export function loadCouponPkgCompletion(pkgId, error, data) {
  return {
    type: 'LOAD_COUPON_PKG_COMPLETION',
    pkgId,
    error,
    data,
  };
}

export function takeCouponPkg(pkgId) {
  return {
    type: 'TAKE_COUPON_PKG',
    pkgId,
  };
}

export function takeCouponPkgCompletion(pkgId, error, data) {
  return {
    type: 'TAKE_COUPON_PKG_COMPLETION',
    pkgId,
    error,
    data,
  };
}

export function loadRegCouponPkg(pkgId) {
  return {
    type: 'LOAD_REG_COUPON_PKG',
    pkgId,
  };
}

export function loadRegCouponPkgCompletion(pkgId, error, data) {
  return {
    type: 'LOAD_REG_COUPON_PKG_COMPLETION',
    pkgId,
    error,
    data,
  };
}

export function takeRegCouponPkg(pkgId) {
  return {
    type: 'TAKE_REG_COUPON_PKG',
    pkgId,
  };
}

export function takeRegCouponPkgCompletion(pkgId, error, data) {
  return {
    type: 'TAKE_REG_COUPON_PKG_COMPLETION',
    pkgId,
    error,
    data,
  };
}

/**
 * 获取门店券详情
 * @param query
 * @returns {{query, type: string, willReload: boolean}}
 */
export function fetchStoreCouponDetail(query) {
  return {type: 'FETCH_STORE_COUPON_DETAIL', query, willReload: !!query}
}

/**
 * 获取门店券详情 - 完成
 * @param error
 * @param detail
 * @returns {{detail, type: string, error}}
 */
export function fetchStoreCouponDetailCompletion(error, detail) {
  return {
    type: 'FETCH_STORE_COUPON_DETAIL_COMPLETION',
    error,
    detail
  }
}

export function loadCouponBatchList(query) {
  return {
    type: 'LOAD_COUPON_BATCH_LIST',
    query,
    willReload: !!query,
  };
}
export function loadCouponBatchListCompletion(error, list) {
  return {
    type: 'LOAD_COUPON_BATCH_LIST_COMPLETION',
    error,
    list,
  };
}

export function loadCouponBatchDonateList(query) {
  return {
    type: 'LOAD_COUPON_BATCH_DONATE_LIST',
    query,
  };
}
export function loadCouponBatchDonateListCompletion(error, list) {
  return {
    type: 'LOAD_COUPON_BATCH_DONATE_LIST_COMPLETION',
    error,
    list,
  };
}
